<template>
    <div id="content">
        <div class="admin-page-header">
            <div>
                <h1 class="admin-page-title">{{ user.username ? $t('cabinet.welcomeNamed', { name: user.username }) : $t('cabinet.welcome') }}</h1>
                <p class="admin-page-subtitle">{{ $t('cabinet.subtitle') }}</p>
            </div>
            <span v-if="user.role" class="admin-pill admin-pill-purple">
                <i class="bi bi-shield-check"></i>
                {{ user.role === 'admin' ? $t('cabinet.roleAdmin') : $t('cabinet.roleUser') }}
            </span>
        </div>
        <div class="row g-4">
            <div class="col-lg-6">
                <div class="admin-card admin-card-hover h-100">
                    <div class="admin-section-label">
                        <i class="bi bi-person-circle"></i>
                        {{ $t('cabinet.account') }}
                    </div>
                    <div class="cabinet-card-body">
                        <div class="cabinet-field">
                            <span class="cabinet-field-label">{{ $t('cabinet.login') }}</span>
                            <span class="cabinet-field-value">{{ user.username }}</span>
                        </div>
                        <div class="cabinet-field" v-if="user.role">
                            <span class="cabinet-field-label">{{ $t('cabinet.role') }}</span>
                            <span class="admin-pill admin-pill-purple">
                                {{ user.role === 'admin' ? $t('cabinet.roleAdmin') : $t('cabinet.roleUser') }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="admin-card admin-card-hover h-100">
                    <div class="admin-section-label">
                        <i class="bi bi-lightning-charge-fill"></i>
                        {{ $t('cabinet.plan') }}
                    </div>
                    <div class="cabinet-card-body">
                        <h4 class="plan-title text-gradient">{{ user.title || $t('cabinet.free') }}</h4>
                        <div class="plan-details">
                            <div class="plan-detail" v-if="user.humanPrice">
                                <i class="bi bi-wallet2"></i>
                                <span>{{ user.humanPrice }}</span>
                            </div>
                            <div class="plan-detail" v-if="expiry">
                                <i class="bi bi-calendar-check"></i>
                                <span>{{ $t('cabinet.until', { date: expiry }) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { cycles, tsToHuman } from '../../lib/utils'

export default {
    data:() => ({
        user: {},
        cycles: cycles,
        expiry: ''
    }),
    async mounted() {
        await this.getUser()
        this.$emit('setPageTitle', '')
    },
    methods: {
        async getUser() {
            let r = await this.$api.getUser()
            if(r.result === 'SUCCESS') {
                this.user = r.data
                this.user.humanPrice = this.user.price ? `${this.user.price.toLocaleString()} ₸ / ${cycles[this.user.cycle - 1].text || this.$t('cabinet.month')}` : this.$t('cabinet.freePrice')
                this.expiry = tsToHuman(this.user.expiry)
            }
        }
    }
}
</script>

<style scoped>
.cabinet-card-body {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.cabinet-field {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
}

.cabinet-field-label {
    font-size: 13px;
    color: #64748b;
    font-weight: 500;
}

.cabinet-field-value {
    font-size: 14px;
    font-weight: 600;
    color: #0f172a;
}

.plan-title {
    font-size: 22px;
    font-weight: 700;
    margin: 0 0 12px;
}

.plan-details {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.plan-detail {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #475569;
}

.plan-detail .bi {
    font-size: 15px;
    color: #7c3aed;
    width: 18px;
    text-align: center;
}
</style>
